

import Vue from 'vue'

import VueRouter from 'vue-router'
import App from './App'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import routes from '@/router/index'
import global_ from '@/utils/globalConst'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'quill/dist/quill.core.css'

Vue.use(ElementUI)




Vue.use(ToastPlugin)
Vue.prototype.MyGlobal = global_
Vue.use(VueRouter)

const router = new VueRouter({
routes
})



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js